
import chatAvatarImage from "../assets/chat-avatar.png";
import {
  ChatDocumentIcon,
  ChatCameraIcon,
  ChatGalleryIcon,
  ChatAudioIcon,
  ChatLocationIcon,
  ChatContactIcon,
} from "../components/common/IconComponents";

export const rows = [
  
  {
    id: 1,
    Name: "Shakirat Akanji",
    dob: "1990-01-01",
    nationalId: "123456789",
    bvn: "987654321",
    address: "123 Main St, City",
    Date: "1/5/2023",
    contact: "09028180940",
    email: "shakiratak@gmail.com",
    Officer: "Tofunmi",
    Status: "Approved",
    Action: "Download",
  },
  {
    id: 2,
    ob: "1990-01-01",
    nationalId: "123456789",
    bvn: "987654321",
    address: "123 Main St, City",
    Name: "Tofunmi Idowu",
    Date: "30/4/2023",
    Officer: "Constance",
    Status: "Pending",
    Action: "Download",
  },
  {
    id: 3,
    Name: "Naomi Igimoh",
    Date: "25/4/2023",
    Officer: "Shakirat",
    Status: "Disapproved",
    Action: "Download",
  },
  {
    id: 4,
    Name: "Edu Hermanns",
    Date: "20/4/2023",
    Officer: "Tofunmi",
    Status: "Approved",
    Action: "Download",
  },
  {
    id: 5,
    Name: "Timmy Adubi",
    Date: "1/5/2023",
    Officer: "Tofunmi",
    Status: "Approved",
    Action: "Download",
  },
  {
    id: 6,
    Name: "Alex Oyebade",
    Date: "1/5/2023",
    Officer: "Shakirat",
    Status: "Disapproved",
    Action: "Download",
  },
  {
    id: 7,
    Name: "Ekene Smart",
    Date: "1/5/2023",
    Officer: "Shakirat",
    Status: "Disapproved",
    Action: "Download",
  },
  {
    id: 8,
    Name: "Adesewa fig",
    Date: "1/5/2023",
    Officer: "Constance",
    Status: "Approved",
    Action: "Download",
  },
  {
    id: 9,
    Name: "Jane Ibude",
    Date: "1/5/2023",
    Officer: "Shakirat",
    Status: "Pending",
    Action: "Download",
  },
  {
    id: 10,
    Name: "Habibah Anu",
    Date: "20/4/2023",
    Officer: "Tofunmi",
    Status: "Pending",
    Action: "Download",
  },
  {
    id: 11,
    Name: "Ridwan Bolaji",
    Date: "20/4/2023",
    Officer: "Tofunmi",
    Status: "Approved",
    Action: "Download",
  },
  {
    id: 12,
    Name: "Aishat Amoke",
    Date: "20/4/2023",
    Officer: "Constance",
    Status: "Approved",
    Action: "Download",
  },
  {
    id: 13,
    Name: "Shakirat Akanji",
    Date: "1/5/2023",
    Officer: "Tofunmi",
    Status: "Approved",
    Action: "Download",
  },

  {
    id: 14,
    Name: "Adesewa fig",
    Date: "1/5/2023",
    Officer: "Constance",
    Status: "Approved",
    Action: "Download",
  },
  {
    id: 15,
    Name: "Jane Ibude",
    Date: "1/5/2023",
    Officer: "Shakirat",
    Status: "Pending",
    Action: "Download",
  },
  {
    id: 16,
    Name: "Habibah Anu",
    Date: "20/4/2023",
    Officer: "Tofunmi",
    Status: "Pending",
    Action: "Download",
  },

  {
    id: 17,
    Name: "Jane Ibude",
    Date: "1/5/2023",
    Officer: "Shakirat",
    Status: "Pending",
    Action: "Download",
  },
  {
    id: 18,
    Name: "Habibah Anu",
    Date: "20/4/2023",
    Officer: "Tofunmi",
    Status: "Pending",
    Action: "Download",
  },
  {
    id: 19,
    Name: "Ridwan Bolaji",
    Date: "20/4/2023",
    Officer: "Tofunmi",
    Status: "Approved",
    Action: "Download",
  },
  {
    id: 20,
    Name: "Aishat Amoke",
    Date: "20/4/2023",
    Officer: "Constance",
    Status: "Approved",
    Action: "Download",
  },
  {
    id: 21,
    Name: "Shakirat Akanji",
    Date: "1/5/2023",
    Officer: "Tofunmi",
    Status: "Approved",
    Action: "Download",
  },
  {
    id: 22,
    Name: "Tofunmi Idowu",
    Date: "30/4/2023",
    Officer: "Constance",
    Status: "Pending",
    Action: "Download",
  },
  {
    id: 23,
    Name: "Naomi Igimoh",
    Date: "25/4/2023",
    Officer: "Shakirat",
    Status: "Disapproved",
    Action: "Download",
  },
  {
    id: 24,
    Name: "Edu Hermanns",
    Date: "20/4/2023",
    Officer: "Tofunmi",
    Status: "Approved",
    Action: "Download",
  },
  {
    id: 25,
    Name: "Timmy Adubi",
    Date: "1/5/2023",
    Officer: "Tofunmi",
    Status: "Approved",
    Action: "Download",
  },
  {
    id: 26,
    Name: "Alex Oyebade",
    Date: "1/5/2023",
    Officer: "Shakirat",
    Status: "Disapproved",
    Action: "Download",
  },
  {
    id: 27,
    Name: "Ekene Smart",
    Date: "1/5/2023",
    Officer: "Shakirat",
    Status: "Disapproved",
    Action: "Download",
  },
  {
    id: 28,
    Name: "Adesewa fig",
    Date: "1/5/2023",
    Officer: "Constance",
    Status: "Approved",
    Action: "Download",
  },
  {
    id: 29,
    Name: "Jane Ibude",
    Date: "1/5/2023",
    Officer: "Shakirat",
    Status: "Pending",
    Action: "Download",
  },
  {
    id: 30,
    Name: "Habibah Anu",
    Date: "20/4/2023",
    Officer: "Tofunmi",
    Status: "Pending",
    Action: "Download",
  },
  {
    id: 31,
    Name: "Ridwan Bolaji",
    Date: "20/4/2023",
    Officer: "Tofunmi",
    Status: "Approved",
    Action: "Download",
  },
  {
    id: 32,
    Name: "Aishat Amoke",
    Date: "20/4/2023",
    Officer: "Constance",
    Status: "Approved",
    Action: "Download",
  },
];

// Teams/All page data
export const all = [
  {
    id: 1,
    userId: 'PRE0001A',
    name: 'Tofunmi Idowun',
    role: 'Admin',
    lastSeen: '1/5/2023',
  },
  {
    id: 2,
    userId: 'PRE0002U',
    name: 'Constance',
    role: 'Admin',
    lastSeen: '30/4/2023',
  },
  {
    id: 3,
    userId: 'PRE0003A',
    name: 'Shakirat Akanji',
    role: 'Admin',
    lastSeen: '1/5/2023',
  },
  {
    id: 4,
    userId: 'PRE0004U',
    name: 'Edu Hermans',
    role: 'Analyst',
    lastSeen: '30/4/2023',
  },
  {
    id: 5,
    userId: 'PRE0005U',
    name: 'Abdulqudus Adegbite',
    role: 'Analyst',
    lastSeen: '30/4/2023',
  },
  {
    id: 6,
    userId: 'PRE0006U',
    name: 'Mercy Hanns',
    role: 'Analyst',
    lastSeen: '30/4/2023',
  },
  {
    id: 7,
    userId: 'PRE0007U',
    name: 'Adesewa Smart',
    role: 'Admin',
    lastSeen: '30/4/2023'
  },
  {
    id: 8,
    userId: 'PRE0008U',
    name: 'Constance',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 9,
    userId: 'PRE0009U',
    name: 'Alex Oyebade',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 10,
    userId: 'PRE0010U',
    name: 'Chiwendu Adams',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 11,
    userId: 'PRE0011A',
    name: 'Timmy Adubi',
    role: 'Admin',
    lastSeen: '1/5/2023'
  },
  {
    id: 12,
    userId: 'PRE0012A',
    name: 'Tofunmi',
    role: 'Admin',
    lastSeen: '1/5/2023'
  },
  {
    id: 13,
    userId: 'PRE0010U',
    name: 'Chiwendu Adams',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 14,
    userId: 'PRE0011A',
    name: 'Timmy Adubi',
    role: 'Admin',
    lastSeen: '1/5/2023'
  },
  {
    id: 15,
    userId: 'PRE0012A',
    name: 'Tofunmi',
    role: 'Admin',
    lastSeen: '1/5/2023'
  },
  {
    id: 16,
    userId: 'PRE0010U',
    name: 'Chiwendu Adams',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 17,
    userId: 'PRE0011A',
    name: 'Timmy Adubi',
    role: 'Admin',
    lastSeen: '1/5/2023'
  },
  {
    id: 18,
    userId: 'PRE0012A',
    name: 'Tofunmi',
    role: 'Admin',
    lastSeen: '1/5/2023'
  },
  {
    id: 19,
    userId: 'PRE0010U',
    name: 'Chiwendu Adams',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 20,
    userId: 'PRE0011A',
    name: 'Timmy Adubi',
    role: 'Analyst',
    lastSeen: '1/5/2023'
  },
  {
    id: 21,
    userId: 'PRE0012A',
    name: 'Tofunmi',
    role: 'Analyst',
    lastSeen: '1/5/2023'
  },
  {
    id: 22,
    userId: 'PRE0002U',
    name: 'Constance',
    role: 'Analyst',
    lastSeen: '30/4/2023',
  },
  {
    id: 23,
    userId: 'PRE0003A',
    name: 'Shakirat Akanji',
    role: 'Admin',
    lastSeen: '1/5/2023',
  },
  {
    id: 24,
    userId: 'PRE0004U',
    name: 'Edu Hermans',
    role: 'Analyst',
    lastSeen: '30/4/2023',
  },
  {
    id: 25,
    userId: 'PRE0005U',
    name: 'Abdulqudus Adegbite',
    role: 'Analyst',
    lastSeen: '30/4/2023',
  },
  {
    id: 26,
    userId: 'PRE0006U',
    name: 'Mercy Hanns',
    role: 'Analyst',
    lastSeen: '30/4/2023',
  },
  {
    id: 27,
    userId: 'PRE0007U',
    name: 'Adesewa Smart',
    role: 'Admin',
    lastSeen: '30/4/2023'
  },
  {
    id: 28,
    userId: 'PRE0008U',
    name: 'Constance',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 29,
    userId: 'PRE0009U',
    name: 'Alex Oyebade',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 30,
    userId: 'PRE0010U',
    name: 'Chiwendu Adams',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 31,
    userId: 'PRE0011A',
    name: 'Timmy Adubi',
    role: 'Analyst',
    lastSeen: '1/5/2023'
  },
  {
    id: 32,
    userId: 'PRE0012A',
    name: 'Tofunmi',
    role: 'Analyst',
    lastSeen: '1/5/2023'
  },
  {
    id: 33,
    userId: 'PRE0010U',
    name: 'Chiwendu Adams',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 34,
    userId: 'PRE0011A',
    name: 'Timmy Adubi',
    role: 'Admin',
    lastSeen: '1/5/2023'
  },
  {
    id: 35,
    userId: 'PRE0012A',
    name: 'Tofunmi',
    role: 'Admin',
    lastSeen: '1/5/2023'
  },
  {
    id: 36,
    userId: 'PRE0010U',
    name: 'Chiwendu Adams',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 37,
    userId: 'PRE0011A',
    name: 'Timmy Adubi',
    role: 'Analyst',
    lastSeen: '1/5/2023'
  },
  {
    id: 38,
    userId: 'PRE0012A',
    name: 'Tofunmi',
    role: 'Analyst',
    lastSeen: '1/5/2023'
  },
  {
    id: 39,
    userId: 'PRE0010U',
    name: 'Chiwendu Adams',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 40,
    userId: 'PRE0011A',
    name: 'Timmy Adubi',
    role: 'Analyst',
    lastSeen: '1/5/2023'
  },
  {
    id: 41,
    userId: 'PRE0012A',
    name: 'Tofunmi',
    role: 'Admin',
    lastSeen: '1/5/2023'
  },
  {
    id: 42,
    userId: 'PRE0008U',
    name: 'Blessing Olusiyan',
    role: 'Admin',
    lastSeen: '30/4/2023'
  },
  {
    id: 43,
    userId: 'PRE0009U',
    name: 'Alex Oyebade',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 44,
    userId: 'PRE0010U',
    name: 'Chiwendu Adams',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 45,
    userId: 'PRE0012A',
    name: 'Dorcas Olaniyan',
    role: 'Admin',
    lastSeen: '1/5/2023'
  },
  {
    id: 46,
    userId: 'PRE0001A',
    name: 'Amarilda Chihepe',
    role: 'Analyst',
    lastSeen: '1/5/2023'
  },
  {
    id: 47,
    userId: 'PRE0002U',
    name: 'Chinenye Osigwe',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 48,
    userId: 'PRE0003A',
    name: 'Odion Akhetuamhen',
    role: 'Analyst',
    lastSeen: '1/5/2023'
  },
  {
    id: 49,
    userId: 'PRE0004U',
    name: 'Ojoachele Onuh',
    role: 'Admin',
    lastSeen: '30/4/2023'
  },
  {
    id: 50,
    userId: 'PRE0012A',
    name: 'Blessing Olusiyan',
    role: 'Analyst',
    lastSeen: '1/5/2023'
  },
  {
    id: 51,
    userId: 'PRE0001A',
    name: 'Amarilda Chihepe',
    role: 'Analyst',
    lastSeen: '1/5/2023'
  },
  {
    id: 52,
    userId: 'PRE0002U',
    name: 'Dorcas Olaniyan',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 53,
    userId: 'PRE0008U',
    name: 'Constance',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 54,
    userId: 'PRE0009U',
    name: 'Alex Oyebade',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 55,
    userId: 'PRE0008U',
    name: 'Amarilda',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 56,
    userId: 'PRE0009U',
    name: 'Alex Oyebade',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 57,
    userId: 'PRE0008U',
    name: 'Blessing',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 58,
    userId: 'PRE0009U',
    name: 'Alex Oyebade',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 59,
    userId: 'PRE0008U',
    name: 'Ojoachele Onuh',
    role: 'Analyst',
    lastSeen: '30/4/2023'
  },
  {
    id: 60,
    userId: 'PRE0009U',
    name: 'Dorcas Olaniyan',
    role: 'Admin',
    lastSeen: '30/4/2023'
  },
];

export const chatCardData = [
  {
    photo: chatAvatarImage,
    name: "Juliet Frank",
    post: "Yes the building is... ",
    time: "12:01",
    badge: "2"
  },
  {
    photo: chatAvatarImage,
    name: "Juliet Frank",
    post: "Yes the building is...",
    time: "12:01",
    // badge: "2"
  },
  {
    photo: chatAvatarImage,
    name: "Juliet Frank",
    post: "Yes the building is...",
    time: "12:01",
    // badge: "2"
  },
  {
    photo: chatAvatarImage,
    name: "Juliet Frank",
    post: "Yes the building is...",
    time: "12:01",
    badge: "2"
  },
  {
    photo: chatAvatarImage,
    name: "Juliet Frank",
    post: "Yes the building is...",
    time: "12:01",
    badge: "2"
  },
  {
    photo: chatAvatarImage,
    name: "Juliet Frank",
    post: "Yes the building is...",
    time: "12:01",
    // badge: "2"
  },
  {
    photo: chatAvatarImage,
    name: "Juliet Frank",
    post: "Yes the building is...",
    time: "12:01",
    // badge: "2"
  },
  {
    photo: chatAvatarImage,
    name: "Juliet Frank",
    post: "Yes the building is...",
    time: "12:01",
    // badge: "2"
  },
];

// Chat data
export const messagesData = [
  { text: 'Hello', sender: 'right' },
  { text: 'Hi, this is Juliet. Please where can we meet to talk', sender: 'left' },
  { text: 'Hi, this is Juliet. Please where can we meet to talk', sender: 'right' },
  { text: 'I’d like to get some information from you', sender: 'right' },
  { text: 'Hi, this Juliet. I just assigned a candidate to you, please check it out.', sender: 'left' },
  { text: 'ok', sender: 'right' },
  { text: 'When are you free?', sender: 'left' },
];

// Emoji array
export const emojiOptions = [
  '😄', '😍', '😃', '😊', '😂', '😢', '😭', '😱', '🙈', '🤗',
  '😉', '😜', '😎', '🤓', '🤥', '🤡', '👻', '😺', '😸', '😼',
  '👽', '💩', '🤖', '🎂', '🎉', '🍾', '🎭', '🎃', '🎩', '🌂',
  '👶', '👩', '👨', '👩‍🍳', '👨‍💼', '👩‍💼', '👨‍🚒', '👩‍🚀', '🤴', '👸',
  '👨‍🎤', '👩‍🎤', '👨‍🎓', '👩‍🎓', '🙅‍♂️', '🙆‍♀️', '🙋‍♂️', '🤷‍♀️', '💆‍♀️', '💇‍♂️',
  '🤦‍♂️', '🧟', '💀', '👊', '👍', '👎', '👏', '👉', '👆', '👇',
  '👈', '🤲', '🙌', '👋', '🤙', '🤘', '🤝', '💪', '🦵', '👂',
  '👀', '👃', '👄', '💋', '🧠', '🫀', '🫁', '🌟', '🌻', '🍕',
  '🎵', '📸', '⚽', '🚀', '🔥', '❤️',
];

// attachment options array
export const options = [
  { type: 'document', icon: <ChatDocumentIcon className="mb-1 w-[36px] h-[36px]" />, label: 'Document' },
  { type: 'camera', icon: <ChatCameraIcon className="mb-1 w-[36px] h-[36px]" />, label: 'Camera' },
  { type: 'gallery', icon: <ChatGalleryIcon className="mb-1 w-[36px] h-[36px]" />, label: 'Gallery' },
  { type: 'audio', icon: <ChatAudioIcon className="mb-1 w-[36px] h-[36px]" />, label: 'Audio' },
  { type: 'location', icon: <ChatLocationIcon className="mb-1 w-[36px] h-[36px]" />, label: 'Location' },
  { type: 'contact', icon: <ChatContactIcon className="mb-1 w-[36px] h-[36px]" />, label: 'Contact' },
];

// // Settings company's profile
// export const dropDownOptions = [
//   { key: "Select", value: "" },
//   { key: "Nigeria", value: "option1" },
//   { key: "Canada", value: "option2" },
//   { key: "USA", value: "option3" },
//   { key: "UK", value: "option4" },
//   { key: "UAE", value: "option5" },
// ];

// // Settings company's profile
// export const dropDownOptions2 = [
//   { key: "Select", value: "" },
//   { key: "Lagos", value: "option1" },
//   { key: "Abuja", value: "option2" },
//   { key: "Port Harcourt", value: "option3" },
//   { key: "Ogun", value: "option4" },
//   { key: "Delta", value: "option5" },
// ];




// INITIAL DATA, NOT USED, LEDT FOR REFERENCE
// // Teams/Admin
// export const admin = [
//   {
//     id: 1,
//     userId: 'PRE0001A',
//     name: 'Tofunmi Idowun',
//     role: 'Admin',
//     lastSeen: '1/5/2023'
//   },
//   {
//     id: 2,
//     userId: 'PRE0002U',
//     name: 'Constance',
//     role: 'Admin',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 3,
//     userId: 'PRE0003A',
//     name: 'Shakirat Akanji',
//     role: 'Admin',
//     lastSeen: '1/5/2023'
//   },
//   {
//     id: 4,
//     userId: 'PRE0004U',
//     name: 'Edu Hermans',
//     role: 'Admin',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 5,
//     userId: 'PRE0005U',
//     name: 'Abdulqudus Adegbite',
//     role: 'Admin',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 6,
//     userId: 'PRE0006U',
//     name: 'Mercy Hanns',
//     role: 'Admin',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 7,
//     userId: 'PRE0007U',
//     name: 'Adesewa Smart',
//     role: 'Admin',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 8,
//     userId: 'PRE0008U',
//     name: 'Blessing Olusiyan',
//     role: 'Admin',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 9,
//     userId: 'PRE0009U',
//     name: 'Alex Oyebade',
//     role: 'Admin',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 10,
//     userId: 'PRE0010U',
//     name: 'Chiwendu Adams',
//     role: 'Admin',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 11,
//     userId: 'PRE0011A',
//     name: 'Timmy Adubi',
//     role: 'Admin',
//     lastSeen: '1/5/2023'
//   },
//   {
//     id: 12,
//     userId: 'PRE0012A',
//     name: 'Dorcas Olaniyan',
//     role: 'Admin',
//     lastSeen: '1/5/2023'
//   },
//   {
//     id: 13,
//     userId: 'PRE0001A',
//     name: 'Amarilda Chihepe',
//     role: 'Admin',
//     lastSeen: '1/5/2023'
//   },
//   {
//     id: 14,
//     userId: 'PRE0002U',
//     name: 'Chinenye Osigwe',
//     role: 'Admin',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 15,
//     userId: 'PRE0003A',
//     name: 'Odion Akhetuamhen',
//     role: 'Admin',
//     lastSeen: '1/5/2023'
//   },
//   {
//     id: 16,
//     userId: 'PRE0004U',
//     name: 'Ojoachele Onuh',
//     role: 'Admin',
//     lastSeen: '30/4/2023'
//   }, 
// ];

// // Teams/Analyst
// export const analyst = [
//   {
//     id: 1,
//     userId: 'PRE0001A',
//     name: 'Tofunmi Idowun',
//     role: 'Analyst',
//     lastSeen: '1/5/2023'
//   },
//   {
//     id: 2,
//     userId: 'PRE0002U',
//     name: 'Constance',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 3,
//     userId: 'PRE0003A',
//     name: 'Shakirat Akanji',
//     role: 'Analyst',
//     lastSeen: '1/5/2023'
//   },
//   {
//     id: 4,
//     userId: 'PRE0004U',
//     name: 'Edu Hermans',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 5,
//     userId: 'PRE0005U',
//     name: 'Abdulqudus Adegbite',
//     role: 'User',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 6,
//     userId: 'PRE0006U',
//     name: 'Mercy Hanns',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 7,
//     userId: 'PRE0007U',
//     name: 'Adesewa Smart',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 8,
//     userId: 'PRE0008U',
//     name: 'Constance',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 9,
//     userId: 'PRE0009U',
//     name: 'Alex Oyebade',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 10,
//     userId: 'PRE0010U',
//     name: 'Chiwendu Adams',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 11,
//     userId: 'PRE0011A',
//     name: 'Timmy Adubi',
//     role: 'Analyst',
//     lastSeen: '1/5/2023'
//   },
//   {
//     id: 12,
//     userId: 'PRE0012A',
//     name: 'Blessing Olusiyan',
//     role: 'Analyst',
//     lastSeen: '1/5/2023'
//   },
//   {
//     id: 13,
//     userId: 'PRE0001A',
//     name: 'Amarilda Chihepe',
//     role: 'Analyst',
//     lastSeen: '1/5/2023'
//   },
//   {
//     id: 14,
//     userId: 'PRE0002U',
//     name: 'Dorcas Olaniyan',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 15,
//     userId: 'PRE0003A',
//     name: 'Shakirat Akanji',
//     role: 'Analyst',
//     lastSeen: '1/5/2023'
//   },
//   {
//     id: 16,
//     userId: 'PRE0004U',
//     name: 'Edu Hermans',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 17,
//     userId: 'PRE0005U',
//     name: 'Abdulqudus Adegbite',
//     role: 'User',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 18,
//     userId: 'PRE0006U',
//     name: 'Chinenye Osigwe',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 19,
//     userId: 'PRE0007U',
//     name: 'Adesewa Smart',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 20,
//     userId: 'PRE0008U',
//     name: 'Ojoachele Onuh',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 21,
//     userId: 'PRE0009U',
//     name: 'Alex Oyebade',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 22,
//     userId: 'PRE0010U',
//     name: 'Chiwendu Adams',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 23,
//     userId: 'PRE0011A',
//     name: 'Timmy Adubi',
//     role: 'Analyst',
//     lastSeen: '1/5/2023'
//   },
//   {
//     id: 24,
//     userId: 'PRE0012A',
//     name: 'Odion',
//     role: 'Analyst',
//     lastSeen: '1/5/2023'
//   },
//   {
//     id: 25,
//     userId: 'PRE0011A',
//     name: 'Timmy Adubi',
//     role: 'Analyst',
//     lastSeen: '1/5/2023'
//   },
//     {
//     id: 26,
//     userId: 'PRE0008U',
//     name: 'Constance',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 27,
//     userId: 'PRE0012A',
//     name: 'Tofunmi',
//     role: 'Analyst',
//     lastSeen: '1/5/2023'
//   },
//   {
//     id: 28,
//     userId: 'PRE0008U',
//     name: 'Constance',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 29,
//     userId: 'PRE0009U',
//     name: 'Alex Oyebade',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 30,
//     userId: 'PRE0010U',
//     name: 'Chiwendu Adams',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 31,
//     userId: 'PRE0012A',
//     name: 'Blessing Olusiyan',
//     role: 'Analyst',
//     lastSeen: '1/5/2023'
//   },
//   {
//     id: 32,
//     userId: 'PRE0001A',
//     name: 'Amarilda Chihepe',
//     role: 'Analyst',
//     lastSeen: '1/5/2023'
//   },
//   {
//     id: 33,
//     userId: 'PRE0002U',
//     name: 'Dorcas Olaniyan',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 34,
//     userId: 'PRE0008U',
//     name: 'Constance',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 35,
//     userId: 'PRE0009U',
//     name: 'Alex Oyebade',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 36,
//     userId: 'PRE0008U',
//     name: 'Amarilda',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 37,
//     userId: 'PRE0009U',
//     name: 'Alex Oyebade',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//     {
//     id: 38,
//     userId: 'PRE0008U',
//     name: 'Blessing',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 39,
//     userId: 'PRE0009U',
//     name: 'Alex Oyebade',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 40,
//     userId: 'PRE0008U',
//     name: 'Ojoachele Onuh',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
//   {
//     id: 41,
//     userId: 'PRE0009U',
//     name: 'Dorcas Olaniyan',
//     role: 'Analyst',
//     lastSeen: '30/4/2023'
//   },
// ];

// Chat data

